export const declensionOfDays = (daysAmount: number) => {
  const lastDigit = daysAmount % 10;
  const lastTwoDigits = daysAmount % 100;

  if (lastDigit === 1 && lastTwoDigits !== 11) {
    return 'день';
  } else if ([2, 3, 4].includes(lastDigit) && ![12, 13, 14].includes(lastTwoDigits)) {
    return 'дня';
  } else {
    return 'дней';
  }
};
